import { DatePicker, Input, Spin } from 'antd';
import Form from 'antd/lib/form';
import { MandateLinkFormType, getNachMandateDetailsResponseData } from 'api/nach';
import moment from 'moment';
import { useEffect, useState } from 'react';

type MandateLinkGridProps = {
  isLoading: boolean;
  data: any;
  autoPay?: boolean;
  sourceType?: string;
};

function RedirectLinkForm({ isLoading, data, autoPay, sourceType }: MandateLinkGridProps) {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState<getNachMandateDetailsResponseData>(data);
  // console.log('sourceType', sourceType);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(data);
    setFormData(data);
  }, [data]);

  useEffect(() => {
    if (sourceType === 'AutoPay') {
      form.setFieldsValue({ mandateAmount: 15000 });
    } else if (sourceType === 'E-NACH') {
      form.setFieldsValue({ mandateAmount: formData?.mandateAmount });
    } else if (sourceType === 'P-NACH') {
      form.setFieldsValue({ mandateAmount: formData?.mandateAmount });
    }
  }, [sourceType, formData]);

  // console.log('Form data', formData);

  useEffect(() => {
    if (autoPay) {
      form.validateFields();
    }
  }, [autoPay]);

  const handleSubmit = () => {
    form.resetFields();
  };

  const currentDate = moment();

  return (
    <>
      <Spin spinning={isLoading}>
        <Form<MandateLinkFormType>
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          scrollToFirstError
          className="standard-forms"
          initialValues={formData}
        >
          <div className="row">
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'Loan Number :'} name="laNumber" className="fieldTitle">
                  <Input
                    placeholder={'Enter Loan Account'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'CIF :'} name="cif" className="fieldTitle">
                  <Input
                    placeholder={'Enter CIF'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'Loan Amount ( ₹ ):'} name="loanAmount" className="fieldTitle">
                  <Input
                    placeholder={'Enter Loan Amount'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'Tenure (In Months):'} name="tenure" className="fieldTitle">
                  <Input
                    placeholder={'Enter Tenure'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Maximum Billing Amount ( ₹ ) :'}
                  name="maxBillingAmount"
                  className="fieldTitle"
                >
                  <Input
                    placeholder={'Enter Maximum Billing Amount'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'Customer Email :'} name="custEMail" className="fieldTitle">
                  <Input
                    placeholder={'Customer Email'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'Phone Number:'} name="phoneNumber" className="fieldTitle">
                  <Input
                    placeholder={'Enter Phone Number'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'Mandate Start Date:'} name="startDate" className="fieldTitle">
                  <DatePicker format={'DD/MM/YYYY'} defaultValue={currentDate} disabled />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item label={'Mandate Amount'} name="mandateAmount" className="fieldTitle">
                  <Input
                    placeholder={'Mandate Amount'}
                    disabled
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Spin>
    </>
  );
}

export default RedirectLinkForm;
